import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import { Autocomplete } from "@mui/material"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import InputAdornment from "@mui/material/InputAdornment"
import SearchIcon from "@mui/icons-material/Search"
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined"
import RestartAltIcon from "@mui/icons-material/RestartAlt"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"


function ComprobantesFilters({ filters, onChange, onSearch, onClear, tiposComprobante = [], sucursalesConsulta, sucursalSelected, setSucursalSelected }) {
  const handleField = (field) => (event) => {
    onChange({ ...filters, [field]: event.target.value })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    onSearch()
  }

  return (
    <Accordion
      elevation={0}
      sx={{
        borderRadius: 10,
        border: "1px solid",
        borderColor: "divider",
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          minHeight: 56,
          "& .MuiAccordionSummary-content": {
            alignItems: "center",
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <FilterAltOutlinedIcon fontSize="small" color="primary" />
          <Typography variant="subtitle1">
            Filtros de búsqueda
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4} md={1.5}>
              <TextField
                label="Fecha desde"
                type="date"
                fullWidth
                size="small"
                value={filters.fechaDesde}
                onChange={handleField("fechaDesde")}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={1.5}>
              <TextField
                label="Fecha hasta"
                type="date"
                fullWidth
                size="small"
                value={filters.fechaHasta}
                onChange={handleField("fechaHasta")}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: filters.fechaDesde,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Cliente"
                placeholder="Razón social"
                fullWidth
                size="small"
                value={filters.cliente}
                onChange={handleField("cliente")}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineIcon fontSize="small" color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                size="small"
                options={sucursalesConsulta || []}
                value={sucursalSelected || null}
                onChange={(e, value) => {
                  setSucursalSelected(value)
                }}
                noOptionsText="No encontrado."
                getOptionLabel={(option) => option?.nombre || ""}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                renderOption={(props, option) => (
                  <Box component="li" {...props} key={option.id}>
                    {option?.nombre?.trim()}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sucursal Factura"
                    placeholder="Buscar sucursal..."
                    variant="outlined"
                  />
                )}
              />

            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="CUIT"
                placeholder="30-12345678-9"
                fullWidth
                size="small"
                value={filters.cuit}
                onChange={handleField("cuit")}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BadgeOutlinedIcon fontSize="small" color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1.5} justifyContent="flex-end" flexWrap="wrap">
                <Button
                  type="button"
                  variant="outlined"
                  color="inherit"
                  startIcon={<RestartAltIcon />}
                  onClick={onClear}
                >
                  Limpiar
                </Button>
                <Button type="submit" variant="contained" startIcon={<SearchIcon />}>
                  Buscar
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>

  )
}

export default ComprobantesFilters
